import { useLayoutEffect, useState } from 'react';

import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { Tooltip } from '@interstate/components/Tooltip';
import { ResizeObserver } from '@makemydeal/dr-shared-ui-utils';

import { ProgramBadge } from './ScenarioDealHeader.style';

export const PROGRAM_NAME_BADGE_TEST_ID = 'scenario-program-badge';

const useIsTextTruncated = (node: HTMLElement | null, text: string) => {
    const [isTruncated, setIsTruncated] = useState(false);

    useLayoutEffect(() => {
        if (!node) return undefined;
        const measure = () => setIsTruncated(node.scrollWidth > node.clientWidth);
        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(node);
        return () => observer.disconnect();
    }, [node, text]);

    return isTruncated;
};

export const ProgramNameBadge = ({ name }: { name: string }) => {
    const theme = useInterstateTheme();
    const [node, setNode] = useState<HTMLElement | null>(null);
    const isTruncated = useIsTextTruncated(node, name);

    const badge = (
        <ProgramBadge ref={setNode} theme={theme} tabIndex={isTruncated ? 0 : undefined} data-testid={PROGRAM_NAME_BADGE_TEST_ID}>
            {name}
        </ProgramBadge>
    );

    return isTruncated ? (
        <Tooltip size="large" position="top" toolTipContent={name}>
            {badge}
        </Tooltip>
    ) : (
        badge
    );
};
